import React, { ReactElement } from 'react';

import { WEB_APP_SIGNUP_URL } from '../../../../../globals';
import * as S from './Card.styles';

type CardProps = {
  title: string;
  description: string;
  imageSrc: string;
}

export const Card = ({ title, description, imageSrc }: CardProps): ReactElement => {
  const handleClickCta = () => {
    window.location.href = WEB_APP_SIGNUP_URL;
  };

  return (
    <S.Wrapper>
      <S.Image src={imageSrc} />
      <S.Header>
        <S.Title>
          {title}
        </S.Title>
        <S.Description>
         {description}
        </S.Description>
      </S.Header>

      <S.ButtonLink onClick={handleClickCta}>
        <span>GET STARTED</span>
        <img alt="arrow" src="https://cdn.brain.fm/icons/arrow-right.svg" />
      </S.ButtonLink>
    </S.Wrapper>
  );
};
